<template lang="pug">
  .env-banner(v-if="visivel") AMBIENTE DE TESTES
</template>

<script>
// Altura da tarja. Quem precisar se ajustar a ela deve usar a variável CSS
// `--env-banner-height` (0px em produção), nunca repetir o valor aqui.
export const ENV_BANNER_HEIGHT = 33;

export default {
  name: 'EnvironmentBanner',
  computed: {
    visivel () {
      return !this.$root.isProduction;
    },
  },
  watch: {
    visivel: 'aplicarAltura',
  },
  created () {
    this.aplicarAltura();
  },
  beforeDestroy () {
    this.aplicarAltura(false);
  },
  methods: {
    aplicarAltura (ativo = this.visivel) {
      const html = document.documentElement;
      html.classList.toggle('has-env-banner', !!ativo);
      html.style.setProperty('--env-banner-height', `${ativo ? ENV_BANNER_HEIGHT : 0}px`);
    },
  },
};
</script>

<style lang="scss">
.env-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 33px;
  line-height: 33px;
  background: #c0392b;
  color: #fff;
  font-weight: bold;
  font-size: 13px;
  text-align: center;
  letter-spacing: 0.5px;
  z-index: 99999;
}

/*
  A tarja é fixa no topo e fica acima de todo o resto. As superfícies em overlay
  do Vuetify (dialogs, navigation drawers usados como modal e snackbars) começam
  em `top: 0`, então teriam o topo coberto pela tarja — aqui elas são deslocadas
  para logo abaixo dela. Regras aplicadas apenas fora de produção.
*/
html.has-env-banner {
  .v-dialog__content {
    top: var(--env-banner-height, 0px);
    height: calc(100% - var(--env-banner-height, 0px));
  }

  .v-navigation-drawer--fixed:not(#appDrawer),
  .v-navigation-drawer--temporary:not(#appDrawer) {
    top: var(--env-banner-height, 0px);
    max-height: calc(100% - var(--env-banner-height, 0px));
  }

  .v-snack--top {
    top: var(--env-banner-height, 0px);
  }
}
</style>
